import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { Link, useTheme } from '@mui/material';
import { useNavState } from '../../navState/NavStateContext';

export const ValMsgCellRenderer = ({ data, value }) => {
  const { navigateTo } = useNavState();
  const theme = useTheme();

  const { dirSaleCodes, dirSaleRefs } = data?.valParams ?? {};
  if (data?.entity !== 'INCTV_RBT' || data?.code !== 'BEST_PRICE' || !dirSaleRefs || typeof value !== 'string') {
    return value;
  }

  let refs;
  try {
    refs = JSON.parse(dirSaleRefs);
  } catch {
    return value;
  }

  const codes = typeof dirSaleCodes === 'string' ? dirSaleCodes.split(', ') : [];
  if (
    !Array.isArray(refs) ||
    !codes.length ||
    refs.length !== codes.length ||
    !refs.every((ref, index) => ref?.id && ref.code === codes[index])
  ) {
    return value;
  }

  const codeText = codes.join(', ');
  const codeTextIndex = value.indexOf(codeText);
  if (codeTextIndex < 0) {
    return value;
  }

  const navigateToDirSale = (event, id) => {
    navigateTo('sc/dir-sale', { entityId: id, mode: Mode.DETAIL }, event.ctrlKey);
  };

  return (
    <>
      {value.slice(0, codeTextIndex)}
      {codes.map((code, index) => (
        <span key={`${refs[index].id}-${index}`}>
          {index > 0 && ', '}
          <Link
            onClick={(event) => navigateToDirSale(event, refs[index].id)}
            sx={{ cursor: 'pointer', color: theme.palette.primary.dark }}
          >
            {code}
          </Link>
        </span>
      ))}
      {value.slice(codeTextIndex + codeText.length)}
    </>
  );
};
